import GenerarCotizacion from './GenerarCotizacion'

export default GenerarCotizacion
